<template>
  <div>
    <div class="app-content--inner p-0 page-add-obat">
      <page-title
        class="custom-breadcrumb"
        heading="Ubah Obat"
        :breadcrumb="[
          {
            label: 'Manajemen Obat & BHP',
            link: '/klinik/obat'
          },
          {
            label: 'Ubah Obat & BHP',
            active: true
          }
        ]"
      />
      <div class="container-fluid __zoom_out_obat">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-box mb-5">
              <div class="card-body p-5" style="padding-top:0px">
                <b-form @submit.prevent="submitinputObat">
                  <div class="row" v-if="satusehatAuthValid">
                    <div class="col-12 col-sm-11 mb-4">
                      <div class="row">
                        <div class="col-12 col-sm-6 pl-0">
                          <div class="outer-obat-tambah">
                            Apabila tidak mengisi KFA, maka data tidak akan sync
                            ke SatuSehat
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <b-row>
                    <b-col sm="11" class="outer-obat-tambah">
                      <b-row>
                        <b-col sm="6">
                          <!-- Kode Obat -->
                          <div class="row pb-3">
                            <div class="col-md-3">
                              <label style="font-size:13px; padding:5px;"
                                >Kode Obat
                                <span style="color:red">*</span></label
                              >
                            </div>
                            <div class="col-md-9">
                              <b-form-input
                                v-model="dataObat.kode_layanan"
                                @input="inputKode($event)"
                                :state="errorState('kode_layanan')"
                                maxlength="10"
                                placeholder="input kode obat"
                              ></b-form-input>
                              <b-form-invalid-feedback>
                                {{
                                  errorData[0] && errorData[0].desc
                                }}
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- Kode KFA -->
                          <div class="row pb-3" v-if="satusehatAuthValid">
                            <div class="col-md-3">
                              <label style="font-size:13px; padding:5px;"
                                >Kode KFA</label
                              >
                            </div>
                            <div class="col-md-7">
                              <vue-select
                                style="font-size:13px"
                                :options="optObatKfa"
                                @input="inputObatKfa($event)"
                                v-model="dataObat.obat_kfa"
                                class="form-select-tarif"
                                placeholder="Tulis kode KFA"
                                @search="debounceSearchObat"
                                :isClearable="true"
                                :keyOpt="'kode_kfa'"
                              />
                              <b-form-invalid-feedback>
                              </b-form-invalid-feedback>
                            </div>
                            <div class="col-md-2">
                              <b-button
                                @click="copyDataKfa"
                                variant="primary"
                                :disabled="!dataObat.obat_kfa"
                                class="w-100 px-2"
                                style="font-size:12px"
                              >
                                <font-awesome-icon icon="clone" />
                                Copy
                              </b-button>
                            </div>
                          </div>

                          <!-- Nama Obat -->
                          <div class="row pb-3">
                            <div class="col-md-3">
                              <label style="font-size:13px; padding:5px;"
                                >Nama Obat
                                <span style="color:red">*</span></label
                              >
                            </div>
                            <div class="col-md-9">
                              <b-form-input
                                v-model="dataObat.nama_layanan"
                                @input="inputNama($event)"
                                :state="errorState('nama_layanan')"
                                maxlength="100"
                                placeholder="input nama obat"
                              ></b-form-input>
                              <b-form-invalid-feedback>
                                {{
                                  errorData[1] && errorData[1].desc
                                }}
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- golongan obat -->
                          <div
                            class="row pb-3"
                            v-if="dataObat.obat_kfa"
                          >
                            <div class="col-md-3">
                              <label style="font-size: 13px;padding:5px;"
                                >Golongan Obat
                              </label>
                            </div>
                            <div class="col-md-9">
                              <b-form-input
                                disabled
                                :value="dataObat.golongan_obat"
                              ></b-form-input>
                              <b-form-invalid-feedback>
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- Kategori -->
                          <div
                            class="row pb-3"
                            v-if="dataObat.obat_kfa"
                          >
                            <div class="col-md-3">
                              <label style="font-size:13px; padding:5px;">
                                Kategori Obat
                              </label>
                            </div>
                            <div class="col-md-9">
                              <b-form-input
                                disabled
                                :value="dataObat.kategori_obat"
                              ></b-form-input>
                              <b-form-invalid-feedback>
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- Bentuk Sediaan -->
                          <div
                            class="row pb-3"
                            v-if="dataObat.obat_kfa"
                          >
                            <div class="col-md-3">
                              <label style="font-size: 13px;padding:5px;"
                                >Bentuk Sediaan
                              </label>
                            </div>
                            <div class="col-md-9">
                              <b-form-input
                                disabled
                                :value="dataObat.bentuk_sediaan"
                              ></b-form-input>
                              <b-form-invalid-feedback>
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- Satuan -->
                          <div class="row pb-3">
                            <div class="col-md-3">
                              <label style="font-size:13px; padding:5px;"
                                >Satuan</label
                              >
                            </div>
                            <div class="col-md-9">
                              <vue-select
                                style="font-size:13px"
                                :options="optSatuan"
                                @input="inputSatuan($event)"
                                v-model="selectedSatuan"
                                class="form-select-tarif"
                                placeholder="pilih satuan"
                              />
                            </div>
                            <b-form-invalid-feedback> </b-form-invalid-feedback>
                          </div>

                          <!-- Jenis -->
                          <div class="row pb-3">
                            <div class="col-md-3">
                              <label style="font-size:13px; padding:5px;">
                                Jenis Obat
                                <span style="color:red">*</span>
                                <font-awesome-icon
                                  v-tooltip="{
                                    content: `<span>Anda dapat memilih 'Lainnya' jika belum mengetahui jenis obat</span><br/>`
                                  }"
                                  class="tooltip-obat"
                                  icon="info-circle"
                                />
                              </label>
                            </div>
                            <div class="col-md-9">
                              <vue-select
                                style="font-size:13px;"
                                :options="optJenis"
                                @input="inputJenis($event)"
                                v-model="selectedJenis"
                                class="form-select-tarif"
                                placeholder="pilih jenis obat"
                              />
                              <b-form-invalid-feedback>
                                {{
                                  errorData[3] && errorData[3].desc
                                }}
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- Komposisi -->
                          <div
                            class="row pb-3"
                            v-if="dataObat.obat_kfa"
                          >
                            <div class="col-md-3">
                              <label style="font-size: 13px;padding:5px;"
                                >Komposisi
                              </label>
                            </div>
                            <div class="col-md-9">
                              <b-form-input
                                disabled
                                :value="dataObat.komposisi"
                              ></b-form-input>
                              <b-form-invalid-feedback>
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- Route -->
                          <div
                            class="row pb-3"
                            v-if="!dataObat.obat_kfa"
                          >
                            <div class="col-12 col-md-3">
                              <label style="font-size:13px; padding:5px;"
                                >Route</label
                              >
                            </div>
                            <div class="col-12 col-md-9">
                              <vue-select
                                style="font-size:13px"
                                :options="optRoute"
                                @input="inputRoute($event)"
                                v-model="selectedRoute"
                                class="form-select-tarif"
                                placeholder="pilih Route"
                                :isClearable="true"
                              />
                              <b-form-invalid-feedback>
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- Stok -->
                          <div
                            class="row pb-3"
                            v-if="!dataObat.obat_kfa"
                          >
                            <div class="col-md-3">
                              <label style="font-size:13px; padding:5px;"
                                >Stok Obat</label
                              >
                            </div>
                            <div class="col-md-9">
                              <div class="d-flex">
                                <b-form-input
                                  v-model="dataObat.stok"
                                  v-on:keypress="NumbersOnly"
                                  maxlength="100"
                                  placeholder="input stok"
                                  :disabled="!stockIsEdit"
                                  class="mr-2"
                                ></b-form-input>
                                <span v-if="!stockIsEdit" @click="enableEdit()" style="cursor: pointer; display: flex; align-items: center;">
                                    <font-awesome-icon icon="pencil-alt" />
                                </span>
                              </div>
                              <b-form-invalid-feedback>
                              </b-form-invalid-feedback>
                            </div>
                          </div>
                        </b-col>

                        <b-col sm="6">
                          <!-- Route -->
                          <div
                            class="row pb-3"
                            v-if="dataObat.obat_kfa"
                          >
                            <div class="col-12 col-md-3">
                              <label style="font-size:13px; padding:5px;"
                                >Route</label
                              >
                            </div>
                            <div class="col-12 col-md-9">
                              <vue-select
                                style="font-size:13px"
                                :options="optRoute"
                                @input="inputRoute($event)"
                                v-model="selectedRoute"
                                class="form-select-tarif"
                                placeholder="pilih Route"
                                :isClearable="true"
                                :disabled="true"
                              />
                              <b-form-invalid-feedback>
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- Manufactur -->
                          <div
                            class="row pb-3"
                            v-if="dataObat.obat_kfa"
                          >
                            <div class="col-md-3">
                              <label style="font-size: 13px;padding:5px;"
                                >Manufactur
                              </label>
                            </div>
                            <div class="col-md-9">
                              <b-form-input
                                disabled
                                :value="dataObat.manufactur"
                              ></b-form-input>
                              <b-form-invalid-feedback>
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- Stok -->
                          <div
                            class="row pb-3"
                            v-if="dataObat.obat_kfa"
                          >
                            <div class="col-md-3">
                              <label style="font-size:13px; padding:5px;"
                                >Stok Obat</label
                              >
                            </div>
                            <div class="col-md-9">
                              <div class="d-flex">
                                <b-form-input
                                  v-model="dataObat.stok"
                                  v-on:keypress="NumbersOnly"
                                  maxlength="100"
                                  placeholder="input stok"
                                  :disabled="!stockIsEdit"
                                  class="mr-2"
                                ></b-form-input>
                                <span v-if="!stockIsEdit" @click="enableEdit()" style="cursor: pointer; display: flex; align-items: center;">
                                    <font-awesome-icon icon="pencil-alt" />
                                </span>
                              </div>
                              <b-form-invalid-feedback>
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- Obat BPJS -->
                          <div class="row pb-3">
                            <div class="col-12 col-md-3">
                              <label style="font-size:13px; padding:5px;"
                                >Obat BPJS</label
                              >
                            </div>
                            <div class="col-12 col-md-9">
                              <vue-select
                                style="font-size:13px"
                                :options="optObatBpjs"
                                v-model="selectedObatBpjs"
                                class="form-select-tarif"
                                placeholder="pilih Obat BPJS"
                                :isClearable="true"
                              />
                              <b-form-invalid-feedback>
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- Het -->
                          <div
                            class="row pb-3"
                            v-if="dataObat.obat_kfa"
                          >
                            <div class="col-md-3">
                              <label style="font-size: 13px;padding:5px;"
                                >Het
                              </label>
                            </div>
                            <div class="col-md-9">
                              <b-form-input
                                disabled
                                :value="dataObat.het"
                              ></b-form-input>
                              <b-form-invalid-feedback>
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- Harga Beli -->
                          <div class="row pb-3">
                            <div class="col-md-3">
                              <label style="font-size:13px; padding:5px;"
                                >Harga Beli</label
                              >
                            </div>
                            <div class="col-md-9">
                              <b-form-input
                                v-on:keypress="NumbersOnly"
                                :value="format_money(dataObat.harga_beli)"
                                @input="onInputHargaBeli($event)"
                                :state="errorState('harga_beli')"
                                maxlength="19"
                              ></b-form-input>
                              <b-form-invalid-feedback>
                                {{
                                  errorData[5] && errorData[5].desc
                                }}
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- Margin -->
                          <div class="row pb-3">
                            <div class="col-md-3">
                              <label style="font-size:13px; padding:5px;"
                                >Margin</label
                              >
                            </div>
                            <div class="col-md-9">
                              <b-form-input
                                :value="format_money(dataObat.margin)"
                                maxlength="19"
                                disabled
                              ></b-form-input>
                              <b-form-invalid-feedback>
                                <!-- {{
                                  errorData[4] && errorData[4].desc
                                }} -->
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- Harga Jual -->
                          <div class="row pb-3">
                            <div class="col-md-3">
                              <label style="font-size:13px; padding:5px;"
                                >Harga Jual
                                <span style="color:red">*</span></label
                              >
                            </div>
                            <div class="col-md-9">
                              <b-form-input
                                :value="format_money(dataObat.tarif)"
                                @input="inputObatLayanan($event)"
                                :state="errorState('tarif')"
                                maxlength="19"
                              ></b-form-input>
                              <b-form-invalid-feedback>
                                {{
                                  errorData[4] && errorData[4].desc
                                }}
                              </b-form-invalid-feedback>
                            </div>
                          </div>

                          <!-- Catatan -->
                          <div class="row pb-3" style="align-items:baseline;">
                            <div class="col-md-3">
                              <label style="font-size:13px; padding:5px;"
                                >Catatan</label
                              >
                            </div>
                            <div class="col-md-9">
                              <b-form-textarea
                                rows="4"
                                no-resize
                                v-model="dataObat.note"
                                placeholder="input catatan pendukung. Contoh: Masa berlaku obat 20 September 2025, pembelian batch 1."
                              ></b-form-textarea>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>

                  <b-row class="d-flex align-items-center mt-4">
                    <b-col lg="11 p-0">
                      <div align="right">
                        <b-button
                          class="text-capitalize mr-2"
                          variant="danger"
                          :to="{ path: '/klinik/obat' }"
                          >keluar</b-button
                        >
                        <b-button
                          class="text-capitalize"
                          type="submit"
                          variant="primary"
                          >simpan</b-button
                        >
                      </div>
                    </b-col>
                  </b-row>
                </b-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import startCase from "lodash/startCase";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faPlus,
  faMinus,
  faInfoCircle,
  faPencilAlt,
  faClone
} from "@fortawesome/free-solid-svg-icons";
import { mapGetters } from "vuex";
import debounce from "lodash/debounce";
library.add(faPlus, faMinus, faInfoCircle,faPencilAlt, faClone);
import { VMoney } from "v-money";

export default {
  components: {
    "vue-select": () => import("@/components/VueSelect.vue"),
  },
  computed: {
    ...mapGetters(["getKlinikId", "getRolesName", "satusehatAuthValid"])
  },
  directives: {
    money: VMoney
  },
  data() {
    return {
      status: false,
      dataObat: {
        klinik_id: null,
        kode_layanan: null,
        nama_layanan: null,
        tarif: null,
        kategori_obat_id: null,
        jns_obat_id: null,
        stok: null,
        satuan_id: null,
        note: null,
        obat_kfa: null,
        obat_kfa_id: null, // This corresponds to kfa_product_id in the API
        golongan_obat: '-',
        bentuk_sediaan: null,
        komposisi: null,
        route: null,
        route_id: null, // This corresponds to route_obat_id in the API
        manufactur: null,
        obat_bpjs: null,
        het: "-",
        harga_beli: 0,
        margin: 0,
        first_stok_added: null, // Additional field from API response
        kategori_obat: null, // Full kategori_obat object
        jenis_obat: null, // Full jenis_obat object
        satuan: null, // Full satuan object
        last_stock_log: null // Additional field from API response
      },
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "Rp",
        suffix: "",
        precision: 0
      },
      selectedKategori: [],
      selectedJenis: [],
      selectedSatuan: [],
      selectedRoute: [],
      selectedObatBpjs: [],
      selectedKelompok: "B",
      optJenis: [],
      optKategori: [],
      optSatuan: [],
      optRoute: [],
      optObatKfa: [],
      optObatBpjs: ["Ya", "Tidak"],
      beingSubmit: false,
      obatId: null,
      errorData: [
        {
          label: "kode_layanan",
          desc: null,
          error: null
        },
        {
          label: "nama_layanan",
          desc: null,
          error: null
        },
        {
          label: "kategori_obat_id",
          desc: null,
          error: null
        },
        {
          label: "jns_obat_id",
          desc: null,
          error: null
        },
        {
          label: "tarif",
          desc: null,
          error: null
        },
        {
          label: "harga_beli",
          desc: null,
          error: null
        }
      ],
      stockIsEdit: false,
    };
  },
  mounted() {
    this.obatId = this.$router.currentRoute.params.id;
    this.getData(this.obatId);
    this.getKategori();
    this.getJenis();
    this.getSatuan();
    this.getRoute();
  },
  beforeRouteLeave(to, from, next) {
    if (!this.beingSubmit && localStorage.getItem("IDLE") != 1 && this.status) {
      this.$swal({
        title: startCase("keluar"),
        html: `Apakah Anda yakin untuk keluar dari halaman ini?<br>Data yang telah ditulis tidak akan tersimpan.`,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: startCase("tidak"),
        confirmButtonText: startCase("ya")
      }).then(res => {
        if (res.value) {
          next();
        } else {
          next(false);
        }
      });
    } else {
      next();
    }
  },
  methods: {
    async getData(id) {
      try {
        const res = await this.$axios.get(`klinik/obat/${id}?klinik_id=${this.getKlinikId}`);
        const { data, success } = res.data;

        if (success) {
          this.$nextTick(() => {
            this.dataObat = {
              klinik_id: this.getKlinikId,
              kode_layanan: data.kode_layanan,
              nama_layanan: data.nama_layanan,
              tarif: data.tarif,
              kategori_obat_id: data.kategori_obat_id,
              jns_obat_id: data.jns_obat_id,
              stok: data.stok,
              satuan_id: data.satuan_id,
              note: data.note,
              obat_kfa_id: data.kfa_product_id,
              route_id: data.route_obat_id,
              obat_bpjs: data.is_bpjs === 1 ? "Ya" : data.is_bpjs === 0 ? "Tidak" : null, // Convert integer to string value
              harga_beli: data.harga_beli || 0,
              margin: data.margin || 0,
              first_stok_added: data.first_stok_added,
              kategori_obat: data.kategori_obat,
              jenis_obat: data.jenis_obat,
              satuan: data.satuan,
              last_stock_log: data.last_stock_log
            };

            this.selectedKategori = data.kategori_obat ? {
              label: data.kategori_obat.name,
              value: data.kategori_obat.id
            } : null;

            this.selectedJenis = data.jenis_obat ? {
              label: data.jenis_obat.name,
              value: data.jenis_obat.id
            } : null;

            if(data.satuan) {
              this.selectedSatuan = {
                label: data.satuan.name,
                value: data.satuan.id
              }
            }

            if(data.route_obat) {
              this.selectedRoute = {
                label: `${data.route_obat.jenis_route} (${data.route_obat.kategori})`,
                value: data.route_obat.id
              }
            }

            if(data.kfa) {
              this.dataObat.obat_kfa = {
                label: `${data.kfa.kfa_code}-${data.kfa.name}`,
                value: data.kfa.id,
                drug_clasification: data.kfa.drug_clasification,
                generik_label: data.kfa.generik_label,
                satuan: data.kfa.satuan,
                komposisi: data.kfa.komposisi,
                manufacturer: data.kfa.manufacturer,
                het_price: data.kfa.het_price ? parseFloat(data.kfa.het_price) : '-',
                name: data.kfa.name // Add the name property
              };
              
              // Update related fields from KFA data
              this.dataObat.golongan_obat = data.kfa.drug_clasification || '-';
              this.dataObat.kategori_obat = data.kfa.generik_label;
              this.dataObat.bentuk_sediaan = data.kfa.satuan;
              this.dataObat.manufactur = data.kfa.manufacturer;
              this.dataObat.het = data.kfa.het_price ? this.format_money(parseFloat(data.kfa.het_price)) : '-';
              this.dataObat.komposisi = data.kfa.komposisi ? data.kfa.komposisi : "-";
              
              // Only update harga_beli and margin from KFA if not provided in the main data
              if (!data.harga_beli) {
                this.dataObat.harga_beli = 0;
              }
              if (!data.margin) {
                this.dataObat.margin = data.tarif - this.dataObat.harga_beli;
              }
            }

            // Set the selected BPJS from the dataObat value
            this.selectedObatBpjs = this.dataObat.obat_bpjs;

            // Check if editing is allowed based on the API response
            if (res.data.is_edit !== undefined) {
              this.stockIsEdit = res.data.is_edit;
            }

            this.status = true;
          });
          // this.stockIsEdit = res.data.is_edit;
        } else {
          this.$swal({
            type: 'error',
            title: startCase("gagal"),
            text: startCase("Data Tidak Ditemukan")
          }).then(res => {
              this.status = false;
              this.$router.push({
                name: "klinik-obat-list"
              })
          })
          return;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getJenis() {
      try {
        const res = await this.$axios.get(`klinik/obat/jenis`);
        const { data, status } = res.data;
        if (status) {
          this.optJenis = data.map(res => ({
            ...res,
            label: res.name,
            value: res.id
          }));
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getSatuan() {
      try {
        const res = await this.$axios.get(`klinik/satuan/list`);
        const { data, status } = res.data;
        if (status) {
          this.optSatuan = data.map(res => ({
            ...res,
            label: res.label,
            value: res.value
          }));
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getKategori() {
      try {
        const res = await this.$axios.get(`klinik/obat/kategori`);
        const { data, status } = res.data;
        if (status) {
          this.optKategori = data.map(res => ({
            ...res,
            label: res.name,
            value: res.id
          }));
        }
      } catch (error) {
        console.error(error);
      }
    },
    inputNama(val) {
      if (val.length == 0) {
        this.errorData[1].error = true;
        this.errorData[1].desc = "Nama obat harus diisi";
        return;
      } else {
        this.errorData[1].error = null;
        this.errorData[1].desc = null;
      }
    },
    inputKode(val) {
      val = val.toUpperCase();

      if (val.match(/[^a-zA-Z0-9\-]+/) !== null) {
        this.errorData[0].error = true;
        this.errorData[0].desc = "Hanya bisa huruf, angka, dan -";
        return;
      } else if (val.length == 0) {
        this.errorData[0].error = true;
        this.errorData[0].desc = "Kode obat harus diisi";
        return;
      } else if (val.length < 3) {
        this.errorData[0].error = true;
        this.errorData[0].desc = "Kode obat minimal 3 karakter";
        return;
      } else {
        this.errorData[0].error = null;
        this.errorData[0].desc = null;
      }

      if (this._timeoutKodeLayanan) clearTimeout(this._timeoutKodeLayanan);

      this._timeoutKodeLayanan = setTimeout(() => {
        this.$axios
          .post(
            `klinik/obat/cek?kode_layanan=${this.dataObat.kode_layanan}&id_layanan=${this.obatId}&klinik_id=${this.getKlinikId}`
          )
          .then(response => {
            if (response.data.status == false) {
              this.errorData[0].error = true;
              this.errorData[0].desc = "Kode obat tidak boleh sama";
            } else {
              this.errorData[0].error = null;
              this.errorData[0].desc = null;
            }
          })
          .catch(error => {
            console.error(error);
          })
          .finally(() => {
            clearTimeout(this._timeoutKodeLayanan);
          });
      }, 600);
    },
    inputJenis(val) {
      if (val.length == 0 || val == null) {
        this.errorData[3].error = true;
        this.errorData[3].desc = "Jenis harus dipilih";
        return;
      } else {
        this.errorData[3].error = null;
        this.errorData[3].desc = null;
      }
    },
    inputKategori(val) {
      if (val.length == 0 || val == null) {
        this.errorData[2].error = true;
        this.errorData[2].desc = "Kategori harus dipilih";
        return;
      } else {
        this.errorData[2].error = null;
        this.errorData[2].desc = null;
      }
    },
    submitinputObat() {
      this.validateAll();
      
      let isError = false;
      
      // Check if any error exists
      this.errorData.forEach(error => {
        if (error.error === false) {
          isError = true;
        }
      });

      if (!isError) {
        this.processUpdate();
      } else {
        this.$swal({
          type: "warning",
          text: "Silakan cek kembali pengisian data Anda!"
        });
      }
    },
    validateAll() {
      const valItems = [
        // "jns_obat_id",
        // "kategori_obat_id",
        "kode_layanan",
        "nama_layanan"
        // "tarif"
      ];

      valItems.forEach(valItem => {
        if (this.errorData.find(err => err.label === valItem).error == false) return;

        if (this.dataObat[valItem] === null) {
          const errorIndex = this.errorData.findIndex(err => err.label === valItem);
          if (errorIndex !== -1) {
            this.errorData[errorIndex].error = false;
            this.errorData[errorIndex].desc = valItem.replace("_", " ") + " harus diisi";
            // if (
            //   this.errorData[errorIndex].desc == "kategori obat_id harus diisi" ||
            //   this.errorData[errorIndex].desc == "jns obat_id harus diisi"
            // ) {
            //   let keynya = valItem.replace("_obat_id", " ");

            //   if (/kategori/.test(keynya)) {
            //     this.errorData[errorIndex].desc = "Kategori harus dipilih";
            //   } else {
            //     this.errorData[errorIndex].desc = "Jenis harus dipilih";
            //   }
            // }
          }
        } else {
          const errorIndex = this.errorData.findIndex(err => err.label === valItem);
          if (errorIndex !== -1) {
            this.errorData[errorIndex].error = null;
            this.errorData[errorIndex].desc = "";
          }
        }
      });

      // Validate jenis obat separately since it's stored in selectedJenis
      const jenisErrorIndex = this.errorData.findIndex(err => err.label === 'jns_obat_id');
      
      if (jenisErrorIndex !== -1) {
        if (!this.selectedJenis || this.selectedJenis.value === null) {
          this.errorData[jenisErrorIndex].error = false;
          this.errorData[jenisErrorIndex].desc = "Jenis harus dipilih";
        } else {
          this.errorData[jenisErrorIndex].error = null;
          this.errorData[jenisErrorIndex].desc = "";
        }
      }
      
      // Validate harga beli and tarif relationship
      if (this.dataObat.tarif < this.dataObat.harga_beli) {
        const tarifErrorIndex = this.errorData.findIndex(err => err.label === 'tarif');
        if (tarifErrorIndex !== -1) {
          this.errorData[tarifErrorIndex].error = false;
          this.errorData[tarifErrorIndex].desc = "Harga jual tidak boleh kurang dari harga beli";
        }
      }
    },
    async processUpdate() {
      try {
        let sendData = {
          klinik_id: this.getKlinikId,
          kode_layanan: this.dataObat.kode_layanan.toUpperCase(),
          nama_layanan: this.dataObat.nama_layanan,
          tarif: parseInt(this.dataObat.tarif),
          kategori_obat_id: this.selectedKategori ? this.selectedKategori.value : null,
          jns_obat_id: this.selectedJenis ? this.selectedJenis.value : null,
          stok: this.dataObat.stok !== '' && this.dataObat.stok !== null && this.dataObat.stok !== '-' ? parseInt(this.dataObat.stok) : null,
          satuan_id: this.selectedSatuan ? this.selectedSatuan.value : null,
          note: this.dataObat.note,
          kfa_product_id: this.dataObat.obat_kfa_id,
          route_obat_id: this.selectedRoute && this.selectedRoute.value ? this.selectedRoute.value : null,
          is_bpjs: this.selectedObatBpjs === "Ya" ? 1 : this.selectedObatBpjs === "Tidak" ? 0 : null, // Convert string to integer
          harga_beli: parseInt(this.dataObat.harga_beli || 0)
        };
        
        const res = await this.$axios.put(
          `klinik/obat/${this.obatId}`,
          sendData
        );

        const { status, message } = res.data;

        if (status == true) {
          this.$swal({
            type: "success",
            text: "Data Obat berhasil disimpan!"
          }).then(res => {
            if (res.value) {
              this.beingSubmit = true;
              this.$router.push({ path: "/klinik/obat" });
            }
          });
        } else {
          this.$swal({
            type: "warning",
            text: message
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      let charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) || charCode === 46) {
        evt.preventDefault();;
      } else {
        // Only replace if stok is a string
        if (typeof this.dataObat.stok === 'string') {
          this.dataObat.stok = this.dataObat.stok.replace(/-/g,'')
        }
        return true;
      }
    },
    enableEdit(){
    this.$swal({
        title: "Ubah Stok",
        html: `Apakah Anda yakin akan mengubah stok? <br/> Perubahan stok akan mempengaruhi pelaporan.`,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: startCase("tidak"),
        confirmButtonText: startCase("ya")
      }).then(res => {
        if (res.value) {
          this.stockIsEdit = true;
        }
      });
  },
    format_money(value) {
      const { prefix, precision } = this.money;
      const formatter = new Intl.NumberFormat("id-ID", {
        minimumFractionDigits: precision,
        maximumFractionDigits: precision
      });

      return `${prefix}${formatter.format(value)}`;
    },
    inputRoute(data) {
      if (data && data.value) {
        this.selectedRoute = data;
      } else {
        this.selectedRoute = null;
      }
    },
    inputObatKfa(data) {
      if (!data) {
        this.dataObat.obat_kfa_id = null;
        this.dataObat.golongan_obat = '-';
        this.dataObat.kategori_obat = null;
        this.dataObat.bentuk_sediaan = null;
        this.dataObat.komposisi = null;
        this.dataObat.manufactur = null;
        this.dataObat.het = "-";
        return;
      }

      const obat = data;

      this.dataObat.obat_kfa_id = obat.value;
      this.dataObat.golongan_obat = obat.drug_clasification || '-';
      this.dataObat.kategori_obat = obat.generik_label;
      this.dataObat.bentuk_sediaan = obat.satuan;

      // 🔹 cari satuan dari optSatuan berdasarkan label
      const satuanMatch = this.optSatuan.find(
        s =>
          s.label &&
          this.dataObat.bentuk_sediaan &&
          s.label.toLowerCase() === this.dataObat.bentuk_sediaan.toLowerCase()
      );

      if (satuanMatch) {
        this.selectedSatuan = satuanMatch;
        this.dataObat.satuan_id = satuanMatch.value;
      } else {
        this.selectedSatuan = null; // fallback kalau ga ketemu
        this.dataObat.satuan_id = null;
      }

      this.dataObat.komposisi = obat.komposisi ? obat.komposisi : '-';
      this.dataObat.manufactur = obat.manufacturer;
      this.dataObat.het = obat.het_price ? this.format_money(obat.het_price) : '-';

      if(obat.rute_pemberian){
        const rutePemberian = JSON.parse(obat.rute_pemberian);
         this.selectedRoute = this.optRoute.find(route => route.code === rutePemberian.code);
      }
      
      // Update harga_beli based on het_price and recalculate margin
      // this.dataObat.harga_beli = obat.het_price || 0;
      // this.dataObat.margin = this.dataObat.tarif - this.dataObat.harga_beli;
    },
    debounceSearchObat: debounce(function(val) {
      this.searchObat(val);
    }, 500),
    async searchObat(val) {
      if (!val || val === "") {
        this.optObatKfa = [];
        return;
      }

      try {
        const res = await this.$axios.get(
          `kfa/get-product?limit=25&value=${val}`
        );

        const { data, status } = res.data;

        if (status) {
          this.optObatKfa = data.map(res => ({
            ...res,
            label: `${res.kfa_code}-${res.name}`,
            value: res.id
          }));
        }
      } catch (err) {
        console.error(err);
      }
    },
    inputObatLayanan(data) {
      this.errorData[4].error = null;
      this.errorData[4].desc = "";

      // get only digits
      const numeric = this.parseMoney(data);

      // update data
      this.dataObat.tarif = numeric;

      if (this.dataObat.tarif < this.dataObat.harga_beli) {
        this.dataObat.margin = 0;
        this.errorData[4].error = false;
        this.errorData[4].desc = "Harga jual tidak boleh kurang dari harga beli";
      } else {
        this.dataObat.margin = this.dataObat.tarif - this.dataObat.harga_beli;
      }
    },
    parseMoney(value) {
      if (!value) return 0;
      // Hilangkan format "Rp. " dan tanda koma
      return parseFloat(value.replace(/[^\d]/g, "")) || 0;
    },
    onInputHargaBeli(event) {
      this.errorData[4].error = null;
      this.errorData[4].desc = "";

      // get only digits
      const numeric = this.parseMoney(event);

      // update data
      this.dataObat.harga_beli = numeric;

      if (this.dataObat.tarif < this.dataObat.harga_beli) {
        this.dataObat.margin = 0;
        this.errorData[4].error = false;
        this.errorData[4].desc = "Harga jual tidak boleh kurang dari harga beli";
      } else {
        this.dataObat.margin = this.dataObat.tarif - this.dataObat.harga_beli;
      }
    },
    async getRoute() {
      try {
        const res = await this.$axios.get(`kfa/route-obat`);
        const { data, status } = res.data;
        if (status) {
          this.optRoute = data.map(item => ({
            ...item,
            label: `${item.jenis_route} (${item.kategori})`,
            value: item.id
          }));
        }
      } catch (error) {
        console.error(error);
      }
    },
    inputSatuan(data) {
      if (data && data.value) {
        this.selectedSatuan = data;
        this.dataObat.satuan_id = data.value;
      } else {
        this.selectedSatuan = null;
        this.dataObat.satuan_id = null;
      }
    },
    copyDataKfa() {
      if (this.dataObat.obat_kfa) {
        // If the name property exists, use it directly
        if (this.dataObat.obat_kfa.name) {
          this.dataObat.nama_layanan = this.dataObat.obat_kfa.name;
        } else if (this.dataObat.obat_kfa.label) {
          // If name doesn't exist, extract from label (format: "code-name")
          const parts = this.dataObat.obat_kfa.label.split('-');
          if (parts.length > 1) {
            this.dataObat.nama_layanan = parts.slice(1).join('-').trim(); // In case name itself contains dashes
          }
        }
      }
    },
    errorState(label) {
      const errorMap = {
        'kode_layanan': 0,
        'nama_layanan': 1,
        'kategori_obat_id': 2,
        'jns_obat_id': 3,
        'tarif': 4,
        'harga_beli': 5
      };
      
      const index = errorMap[label];
      if (index !== undefined && this.errorData[index]) {
        return this.errorData[index].error;
      } else {
        return null;
      }
    }
  },
};
</script>

<style>
.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: rgb(255, 255, 255);
  color: black;
  border-radius: 5px;
  padding: 5px 10px 4px;
  box-shadow: 0px 0px 0px rgba(black, 0.1) !important;
  border-style: solid;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
}

.custom-breadcrumb div.row ol.breadcrumb li.breadcrumb-item.active {
  text-transform: capitalize !important;
}
</style>

<style lang="scss">
.__zoom_out_obat {
  zoom: 80%;
}

.outer-obat-tambah {
  position: relative;
  border-radius: 10px;
  border: 2px solid #bfbfbf;
  outline-color: #bfbfbf;
  padding: 15px;
  outline-width: thin;
}

.form-select-tarif
  .vs__dropdown-toggle
  .vs__selected-options
  .vs__search::placeholder {
  color: #d1d2db !important;
}

.custom-breadcrumb div.row ol.breadcrumb li.breadcrumb-item.active {
  text-transform: capitalize !important;
}

.page-add-obat {
  .vs__dropdown-option {
    white-space: wrap;
  }
  .vs--single .vs__selected {
    width: 90%;
  }

  .vs__selected-options {
    width: 80%;
  }

  .vs__selected-options .vs__selected {
    width: 87%;
  }

  .no-overflow {
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .form-control {
    font-size: 13px;
    padding-left: 10px;
  }
}
</style>

<style lang="scss" scoped>
.form-inline label {
  display: -moz-box;
  display: flex;
  -moz-box-align: center;
  align-items: center;
  -moz-box-pack: center;
  justify-content: flex-start;
  margin-bottom: 0;
}

.invalid-feedback {
  // margin-left: 150px !important;
  min-height: 18px;
  display: block;
}
</style>
